/* DSA kopieerbeveiliging. Afschrikking, geen echte beveiliging. Niet actief in de theme-editor. */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;

  const ALLOWED = 'input, textarea, select, [contenteditable="true"], [data-dsa-allow]';
  const isAllowed = (el) => !!(el && el.closest && el.closest(ALLOWED));
  const block = (e) => {
    if (!isAllowed(e.target) && !isAllowed(document.activeElement)) e.preventDefault();
  };

  document.addEventListener('contextmenu', (e) => {
    if (!isAllowed(e.target)) e.preventDefault();
  });
  ['copy', 'cut', 'dragstart', 'selectstart'].forEach((type) => document.addEventListener(type, block));

  document.addEventListener('keydown', (e) => {
    const key = (e.key || '').toLowerCase();
    const mod = e.ctrlKey || e.metaKey;

    // Ontwikkelaarstools
    if (e.key === 'F12') return e.preventDefault();
    if (mod && e.shiftKey && ['i', 'j', 'c', 'k'].includes(key)) return e.preventDefault();
    if (e.metaKey && e.altKey && ['i', 'j', 'c', 'u'].includes(key)) return e.preventDefault();
    if (mod && !e.shiftKey && ['u', 's'].includes(key)) return e.preventDefault();

    // Kopiëren en alles selecteren, behalve in invoervelden
    if (mod && ['a', 'c', 'x'].includes(key) && !isAllowed(e.target) && !isAllowed(document.activeElement)) {
      e.preventDefault();
    }
  });
})();
